export default __webpack_public_path__ + "static/media/calendario_resultados.bd55ce87.jpg";